import * as types from '../actions/actionTypes';
import initialState from './initialState';

export default function cursoComboReducer(state= initialState.cursoCombo, action){
	switch(action.type){
		case types.GET_CURSOS_COMBO_SUCCESS:		            
			return action.datos;		
	
		default:
			return state;
	}
}